$w('#quickActionBar1').collapse()